const endpoints = {
	create: '/meetings/create',
	update: '/meetings/update',
	delete: '/meetings/delete',
	getMeeting: '/meetings/getMeeting',
	getMyMeetingsByProject: '/meetings/getMyMeetingsByProject',
	addInteraction: '/meetings/addInteraction',
	markMeetingAsRead: '/meetings/markMeetingAsRead',
	changeVisualizationStatus: '/meetings/changeVisualizationStatus',
	getPdf: '/meetings/pdf',
	downloadPdf: '/meetings/pdf/download',
	sendPdfEmail: '/meetings/sendPdfEmail',
}
export {endpoints}